import BulkRequestDriverInformation from "../../services/api/BulkRequestDriverInformation";
import { setLoader, setStatus } from "./User";
import Errors from "../../constants/Errors.json";

const handleError = (err) => {
  console.log("Error in bulk request driver information actions", err);
};

export const getUploadUrl = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await BulkRequestDriverInformation.getUploadUrl(payload);
    dispatch(setLoader(false));
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
